import {
  BoxContainer,
  PageContent,
  SrcInfoContainer
} from '@nile/banyan/src/Utils/style';
import {
  Button,
  Card,
  Checkbox,
  RadioButton,
  Stack,
  TextField
} from '@shopify/polaris';
import dompurify from 'dompurify';
import React, { Component, useCallback, useState } from 'react';
import Rating from 'react-rating';
import Select from 'react-select';
import styled from 'styled-components';

const InfoContainer = styled(SrcInfoContainer)`
  .Polaris-Subheading {
    margin-top: 8px !important;
  }
`;

function SurveyOptions(props) {
  const [value, setValue] = useState('automatic');
  const [selected, setSelected] = useState(['TICKET_CLOSE']);

  const handleSelectedStatus = useCallback((value) => {
    setSelected(value);
  }, []);
  const handleChange = useCallback((_checked, newValue) => {
    setValue(newValue);
  }, []);

  const status = [
    {
      label: 'Ticket close',
      value: 'TICKET_CLOSE'
    },
    {
      label: 'Ticket reolve',
      value: 'TICKET_RESOLVE'
    }
  ];

  return (
    <div>
      <Stack vertical>
        <RadioButton
          label="Automatically for all"
          checked={value === 'automatic'}
          id="automatic"
          name="accounts"
          onChange={handleChange}
        />
        {value === 'automatic' && (
          <div className="w280">
            <Select
              defaultValue={status[0]}
              onChange={handleSelectedStatus}
              options={status}
            />
          </div>
        )}
        <RadioButton
          label="Manually by technician"
          id="manual"
          name="accounts"
          checked={value === 'manual'}
          onChange={handleChange}
        />
      </Stack>
    </div>
  );
}

class FeedbackCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: true,
      inputValue: '',
      value: [],
      points: 0,
      selectedFeedback: props.sops.length > 0 ? props.sops[0] : []
    };
  }

  renderSubItem = (item) => {
    this.setState({ selectedFeedback: item });
  };

  changeState = () => {
    const { editMode } = this.state;
    this.setState({ editMode: !editMode });
  };

  enableComment = () => {};

  saveSurvey = (item) => {
    this.changeState();
  };

  render() {
    const { selectedFeedback, editMode, enableCommments } = this.state;

    return (
      <BoxContainer className="fx bshadow">
        <Card>
          <InfoContainer>
            <div className="fx2">
              <div className="w50 formHeader f-20 mt-14 mb-14">
                {' '}
                Survey Condition -Edit{' '}
              </div>
            </div>
            <div className="fx jend actr">
              {editMode ? (
                <Button secondary onClick={this.saveSurvey.bind(this)}>
                  Save
                </Button>
              ) : (
                <Button secondary onClick={this.changeState.bind(this)}>
                  Edit
                </Button>
              )}
            </div>
          </InfoContainer>

          {editMode ? (
            <PageContent height={'50vh'} className="col">
              <div>
                <h3>Intiated this survey </h3>
                <SurveyOptions></SurveyOptions>
              </div>
              {selectedFeedback.enableCommments && (
                <span>
                  <Card>
                    <div className="w50 formHeader f-20 mt-14 mb-14">
                      {' '}
                      Survey Question{' '}
                    </div>
                    <h3>{selectedFeedback.question}</h3>
                    {/* This is temp changes need to make xss free content loader */}
                    <Rating {...this.props} initialRating={this.state.points} />
                  </Card>

                  {selectedFeedback.enableCommments && (
                    <Card>
                      <div className="w50 f-20 mt-14 mb-14">
                        {' '}
                        Additional comments
                      </div>
                      <TextField
                        value={selectedFeedback.comments}
                        multiline={2}
                      />
                    </Card>
                  )}
                </span>
              )}
            </PageContent>
          ) : (
            <PageContent height={'48vh'} className="col">
              <div>
                <h3>
                  Intiated this survey <b>Automatlically</b> for all{' '}
                  <b>close</b> tickets{' '}
                </h3>
              </div>
              {/* {selectedFeedback.enableCommments && ( */}
              <span>
                <Card>
                  <div className="w50 formHeader f-20 mt-14 mb-14">
                    {' '}
                    Survey Question{' '}
                  </div>
                  <h3>{selectedFeedback.question}</h3>
                </Card>
                <Card>
                  <Checkbox
                    label="Additional comments"
                    checked={enableCommments}
                    onChange={this.enableComment.bind(this)}
                  />
                  {selectedFeedback.enableCommments && (
                    <TextField
                      value={selectedFeedback.comments}
                      multiline={2}
                    />
                  )}
                </Card>
              </span>
            </PageContent>
          )}
        </Card>
      </BoxContainer>
    );
  }
}

export default FeedbackCascade;
